<template>
    <div>
        <v-container>
            <h1 style="text-align:center">Privacy Policy</h1>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Praesent id sagittis nulla. Morbi ullamcorper accumsan massa eu
                ullamcorper. Vestibulum ante ipsum primis in faucibus orci
                luctus et ultrices posuere cubilia curae; In cursus iaculis
                blandit. Maecenas semper elit pellentesque dui congue dapibus.
                Integer et justo magna. Integer nec quam volutpat, finibus nunc
                non, rutrum turpis. Vestibulum vel interdum justo, nec iaculis
                justo. Proin accumsan varius mauris, vel dignissim dolor gravida
                sed. Nam non fermentum odio. Ut quis ipsum non ante gravida
                fringilla at vestibulum eros. Curabitur et ante iaculis,
                interdum purus in, posuere ipsum. Vestibulum gravida, lacus non
                aliquam aliquet, augue nibh sagittis ligula, quis accumsan neque
                lacus quis ante. Phasellus a metus varius quam sodales mattis
                sed ac nibh. Etiam mattis lacus eu dolor dignissim molestie.
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos. Vestibulum id consequat quam.
                Integer ac convallis risus. Nunc facilisis efficitur turpis,
                ultricies imperdiet tellus maximus et. Nulla placerat dui a
                dictum feugiat. Pellentesque tellus mauris, facilisis sit amet
                luctus sit amet, rutrum in lacus. In rhoncus nibh ut scelerisque
                venenatis. Nulla justo sem, fermentum id dignissim id, hendrerit
                id urna. Donec quis euismod nibh, vitae vestibulum elit.
                Maecenas ultricies tincidunt felis vel euismod. Integer et
                euismod ex, et ultricies sem. Donec eget eros eget tellus
                interdum porttitor. Quisque elementum velit sit amet consectetur
                aliquam. Donec ultricies faucibus lectus finibus elementum. Ut
                ullamcorper auctor rhoncus. Vivamus ornare erat nisi, eu tempor
                lorem rutrum fermentum. In lorem ipsum, feugiat ac rutrum sed,
                accumsan nec ante. Vestibulum non bibendum odio. Lorem ipsum
                dolor sit amet, consectetur adipiscing elit. Morbi accumsan urna
                vel ante congue, id fringilla lacus tincidunt. Ut a facilisis
                sapien. Sed nunc leo, viverra nec sagittis non, dapibus nec
                ligula. Quisque nec quam urna. In vel dolor suscipit, varius
                nunc interdum, vulputate elit. Nulla vitae dolor est. Integer
                sit amet porttitor eros. Nam consectetur turpis sed mollis
                faucibus. Nullam congue convallis enim, eget elementum enim
                ultricies non. In tincidunt finibus tortor id suscipit.
                Phasellus auctor nisi ac egestas egestas. Etiam justo nulla,
                dictum nec cursus id, luctus vitae sem. Duis consectetur auctor
                mi, non condimentum massa rutrum et. Aenean molestie facilisis
                auctor. Ut et scelerisque lectus. Curabitur hendrerit lectus in
                mi mollis, ac placerat turpis molestie. Donec faucibus egestas
                elit, at mattis ligula lacinia et. Proin ac posuere nunc. Sed
                sed diam at nulla auctor dignissim eget luctus lectus. Sed
                euismod neque risus, non commodo tortor fringilla in. Donec
                aliquam purus scelerisque tellus mattis, quis cursus lacus
                sollicitudin.
            </p>
        </v-container>
    </div>
</template>

<script>
export default {};
</script>

<style></style>
